import { Close } from '@material-ui/icons'

import { Button } from '@baseV2'
import { strings } from '@constants'

import { AddShipmentTab, RightSectionHeader, ShipmentTab, TabCloseIcon, TabStrip } from '../styles'

// Tab strip for the shipments being composed on this page. Every tab shows its full name unless
// `shortPrefix` is passed, in which case only the active one does and the others collapse to
// <prefix>1 / <prefix>2 / … (e.g. D1 / D2 for dispatch plans).
// The active tab carries a cross that removes that shipment, and the trailing "+" adds one.
const ShipmentTabs = ({
	tabs = [],
	activeId,
	onTabChange,
	onAddTab,
	onRemoveTab,
	addDisabled,
	onAutofill,
	autofillDisabled,
	hideAutofill = false,
	// optional button pinned to the right end of the strip: { label, onClick }
	rightAction,
	shortPrefix,
	addTitle = 'Add shipment',
}) => {
	// the last shipment can't be removed — the form would have nothing to render
	const removable = tabs.length > 1

	return (
		<RightSectionHeader>
			<TabStrip>
				{tabs.map((tab, index) => {
					const selected = tab.id === activeId

					return (
						<ShipmentTab key={tab.id} type='button' title={tab.label} $selected={selected} onClick={() => onTabChange?.(tab.id)}>
							{selected || !shortPrefix ? tab.label : `${shortPrefix}${index + 1}`}
							{selected && removable && (
								<TabCloseIcon
									role='button'
									title={strings('remove')}
									onClick={(e) => {
										e.stopPropagation()
										onRemoveTab?.(tab.id)
									}}
								>
									<Close />
								</TabCloseIcon>
							)}
						</ShipmentTab>
					)
				})}
				<AddShipmentTab type='button' title={addTitle} disabled={addDisabled} onClick={onAddTab}>
					+
				</AddShipmentTab>
			</TabStrip>
			{!hideAutofill && (
				<Button type='button' variant='outline' size='small' disabled={autofillDisabled} onClick={onAutofill}>
					Autofill
				</Button>
			)}
			{rightAction && (
				<Button type='button' variant='outline' size='small' style={{ marginLeft: 'auto' }} onClick={rightAction.onClick}>
					{rightAction.label}
				</Button>
			)}
		</RightSectionHeader>
	)
}

export default ShipmentTabs
